import React from "react";
import isEqual from "react-fast-compare";
import PostCardFilters from "./PostCardFilters";

const WordCloudPills = ({
  filterPills,
  metadata,
  section_index,
  widget_index,
  deepDive,
  isPreviewState,
  PdfDownloadStatus,
  PptGeneratingStatus,
  widget_id,
  chart_type,
}) => {
  return (
    <>
      <PostCardFilters
        filterPills={filterPills}
        metadata={metadata}
        section_index={section_index}
        widget_index={widget_index}
        deepDive={deepDive}
        isPreviewState={isPreviewState}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        widget_id={widget_id}
        chart_type={chart_type}
      />
    </>
  );
};

export default React.memo(WordCloudPills, isEqual);
